const moment = require('moment')

export default {
  namespaced: true,
  state: {
    timer: {
      tags: [],
      description: '',
      start_timer: '',
      stop_timer: '',
      duration: '',
      total_timer: '00:10:00',
    },
    startTimer: null,
    endTimer: null,
    currentTimer: 0,
    timerState: 'stopped',
    formatedTimer: '00:00:00',
    ticker: undefined,
    laps: [],
    lastestLap: '',
    snackbar: false,
  },
  getters: {
    formatTotalTimer: state => {
      return moment.utc(state.currentTimer * 1000).format('HH:mm:ss')
    },
  },
  mutations: {
    SET_DESCRIPTION_TIMER(state, payload) {
      state.timer.description = payload
    },
  },
  actions: {
    start({ state, dispatch }) {
      if (state.timerState !== 'running') {
        dispatch('tick')
        state.timerState = 'running'
      }
    },
    async tick({ state, dispatch }) {
      state.startTimer = await dispatch('formatDate', new Date())
      state.ticker = setInterval(() => {
        state.currentTimer += 1
        dispatch('formatTime')
      }, 1000)
    },
    async stop({ state, dispatch }) {
      if (state.timerState === 'running') {
        state.endTimer = await dispatch('formatDate', new Date())
        dispatch('setTimerApi')
        state.timerState = 'stopped'
        clearInterval(state.ticker)
        state.lastestLap = state.formatedTimer
        state.formatedTimer = '00:00:00'
        state.currentTimer = 0
        state.snackbar = false
        state.startTimer = 0
        state.endTimer = 0
      }
    },
    formatTime({ state }) {
      const hour = Math.floor(state.currentTimer / 3600)
      const minute = Math.floor((state.currentTimer % 3600) / 60)
      const second = state.currentTimer % 60
      state.formatedTimer = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`
    },
    formatDate(_, payload) {
      return moment(payload).format('YYYY-MM-DD HH:mm:ss')
    },
    async setTimerApi({ state, getters }) {
      state.timer = {
        description: state.timer.description,
        start_timer: state.startTimer,
        stop_timer: state.endTimer,
        duration: state.currentTimer,
        tags: state.timer.tags,
        total_timer: getters.formatTotalTimer,
      }
    },

  },
}
